import Vue from 'vue';
import Vuex from 'vuex';
import storage from '../utils/storage';
import { getUserInfo } from '../api/public'
import { getFunctionDetail } from '../api/api'

// 安装插件
Vue.use(Vuex);

// 创建 store 对象
const store = new Vuex.Store({
    namespaced: false, // 根据实际情况决定是否需要命名空间

    // 存放数据
    state: {
        USERINFO: storage.get('USERINFO') || null, // 用户信息
        OPENID: storage.get('OPENID') || null, // 获取开放id
        fromEscortVerify: storage.get('fromEscortVerify') === 'true' || false 
    },

    // 修改状态的方法
    mutations: {
        /**
         * 更新用户信息
         * @param {Object} state - 状态对象
         * @param {Object|string} data - 用户信息数据，若获取失败则为 ''
         */
        updateUserInfo(state, data) {
            // 处理数据为 null 或 undefined 的情况
            if (data === null || data === undefined) {
                data = '';
            }
            storage.set('USERINFO', data);
            state.USERINFO = data;
        },

        /**
         * 更新开放id
         * @param {Object} state - 状态对象
         * @param {string|null} data - 开放id，若获取失败则为 ''
         */
        updateOpenid(state, data) {
            // 处理数据为 null 或 undefined 的情况
            if (data === null || data === undefined) {
                data = '';
            }
            storage.set('OPENID', data);
            state.OPENID = data;
        },

        /**
         * 设置是否从 escort-verify 页面进入
         * @param {Object} state - 状态对象
         * @param {boolean} flag - 是否从 escort-verify 页面进入
         */
        setFromEscortVerify(state, flag) {
            state.fromEscortVerify = flag;
            // 将标记存入 storage
            storage.set('fromEscortVerify', flag.toString()); 
        }
    },

    // 异步方法
    actions: {
        /**
         * 异步获取用户信息
         * @param {Object} context - 包含 commit 方法的上下文对象
         * @param {string} openid - 用户的开放id
         * @returns {Promise<void>}
         */
        async fetchUserInfo({ commit, state }, openid) {
            if (state.fromEscortVerify) {
                return;
            }
            try {
                if (!openid) {
                    console.error('openid 为空，无法获取用户信息');
                    commit('updateOpenid', '');
                    commit('updateUserInfo', '');
                    return;
                }
                const response = await getUserInfo({ openid });
                // 975 职能分配管理-详情
                const res = await getFunctionDetail({ openid});
                // 如果res.list 有值 说明有职能分配
                if (res.list.length > 0) {
                    response.userFunction = res.list[0];
                }else {
                    response.userFunction = {}
                }
                
                if (response && response.id) {
                    commit('updateUserInfo', response);
                } else {
                    console.error('获取的用户信息不包含 id，清空用户信息和 openid');
                    commit('updateOpenid', '');
                    commit('updateUserInfo', '');
                }
            } catch (error) {
                console.error("获取用户信息失败", error);
                // 出错时清空用户信息和 openid
                commit('updateOpenid', '');
                commit('updateUserInfo', '');
                // 将错误抛出，方便调用处处理
                throw error;
            }
        },

        /**
         * 更新开放id
         * @param {Object} context - 包含 commit 方法的上下文对象
         * @param {string} openid - 用户的开放id
         */
        updateOpenid({ commit }, openid) {
            commit('updateOpenid', openid);
        },
    },
});

export default store;